import React, { useState,useEffect,useRef } from "react";
import { $CommonServiceFn } from "../network/Services";
import $Service_Url from '../network/url'
import { isNotValidNullUndefile ,initMapScript, formatDate} from "../control/Constant";
import ReusableSelect from "./ReusableSelect";
import formatUSPhoneNumber from "../control/Constant";
import { Services } from "../network/Services";
import Loader from "./Loader";
import Toaster from "./Toaster";
import moment from "moment";

const AddStaff = ({getUserListData,setIsOpen}) => {
  const [formData, setFormData] = useState({
    profileImage: null,
    signatureImage: null,
    company: "Life Point Law_Developement India",
    role:[],
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    gender: "",
    citizenship: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    email: "",
    phone: "",
    lattitude :'',
    longitude : '',
    streetAddress :'',
    subtenantId:null,
    speakerLink: "",
    speakerDescription: "",
    charge: "",
    wsbaNumber: "",
    countryCode:'+1'
  });
  const [errors, setErrors] = useState({});
  const [subtenantdata, setsubtenantdata] = useState([])
  const [optionsBackUp, setOptionsBackUp] = useState([])
  const [options, setOptions] = useState([])
  const searchInput = useRef(null)
  const subtenantId = sessionStorage.getItem('SubtenantId')
  const subtenantNames = sessionStorage.getItem('subtenantName')
  const [citizenship, setCitizenship] = useState([]);
  const [countrycode, setcountryCode] = useState([]);
  const [toast, setToast] = useState(null);
  const [useLoader, setuseLoader] = useState(false)
   const inputRef = useRef();
  const newObjErr = () => ({cityErr: "", stateErr: "",countryErr:'', zipCodeErr: "",streetAddressErr:'',expireDateErr:"",cardNumberErr:"",cardNickNameErr:"",cardCvvErr:""});



  useEffect(() => {
     getSubtinentDetails()
     allRolesDetails()
     getCitizenship()
     getcountrycodes()
  }, [])


    const getSubtinentDetails = () => {
        setuseLoader(true)
        let subtenantObj = {
            isActive: true
        }
        $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.getSubtenantDetails, subtenantObj,
            (response) => {
                if (response) {
                    setsubtenantdata(response?.data?.data);
                      setuseLoader(false)
                }
            }
        );
    }

  // Handle text/select inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    hideErrMsg(`${name}`, errors)
    if(name == 'phone'){
      setFormData((prev)=>({...prev,[name]:formatUSPhoneNumber(value)}))
    }else{

      const cursorPosition = e.target.selectionStart;
            const words = value?.split(' ');
            const source = formData;
            const prevWords = source?.[name]?.split(' ') || [];
            const capitalizedValue = words?.length > 0 && words?.map((word, wordIndex) => {
                if (word?.length == 0) return word
                const prevWord = prevWords?.[wordIndex] || '';
                if (prevWord?.length == 0 && word?.length == 1) {
                    return word.charAt(0).toUpperCase()
                }
                return word
            }).join(' ');
                if(['phone','email'].includes(name)){
                   setFormData(prev => ({ ...prev, [name]: value }))
                }else{
                    setFormData(prev => ({ ...prev, [name]: capitalizedValue }))
                }
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
                }
            }, 0)
             //  setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };



  // Handle image upload
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, [field]: file }));
    }
  };





  // Validation
  const validate = () => {
    let newErrors = {};
    if (!formData.role || formData?.role?.length == 0) newErrors.role = "Please select role";
    if (!formData.firstName) newErrors.firstName = "Please input your First Name!";
    if (!formData.lastName) newErrors.lastName = "Please input your Last Name!";
    if (!formData.email) newErrors.email = "Please enter your E-mail";
    if (!formData.city) newErrors.cityErr = "Please input your city!";
    if (!formData.state) newErrors.stateErr = "Please input your state!";
    if (!formData.country) newErrors.countryErr = "Please input your country!";
    if (!formData.zipCode) newErrors.zipCodeErr = "Please input your zipcode!";
    if (!formData.phone) newErrors.phone = "Please enter your phone number!";
    else if (isNotValidNullUndefile(formData.email) && (!/\S+@\S+\.\S+/.test(formData.email)))
      newErrors.email = "Please input your valid email!";
    if (!formData.phone) newErrors.phone = "Please enter your phone number!";
    else if (isNotValidNullUndefile(formData.phone) && (formData.phone.replace(/[\s()-]/g, "").length < 10))
      newErrors.phone = "Please input your valid phone number!";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
    callAddUserApi(formData)
    }
  };


    const callAddUserApi = (data) => {
        const { role, firstName, lastName, middleName, email, phone, charge,countryCode } = formData
        const subtenantId = subtenantdata?.length > 0 && subtenantdata?.find(data => data?.subtenantName == subtenantNames)?.subtenantId || '';
        const userId = sessionStorage.getItem("loggedUserId");
        setuseLoader(true)
        const jsonObjData = {
            subtenantId,
            signUpPlateform: 2,
            createUserCredentials: false,
            createdBy: userId,
            user: {
                roleId: role?.length > 0 ? role[0] : null,
                firstName: firstName,
                mName: middleName,
                lastName: lastName,
                emailAddress: email,
                userName: email,
                countryCode: countryCode,
                mobileNumber: phone?.replace(/[\s()-]/g, ""),
                packageCode: null,
                activateUser: false,
                autoConfirmEmail: false,
                autoConfirmMobile: false,
                userPrice: charge
            }
        };
        PostNewUser(jsonObjData, data);
    };
const PostNewUser = async (jsonObjData, data) => {
  const postAddUserApiCall = Services.subtenantCreateUser(jsonObjData);
  return postAddUserApiCall.then(async (res) => {
      setuseLoader(false)
      const responseData = res?.data?.data;
      const subtenantId = subtenantdata?.length > 0 && subtenantdata?.find((item) => item?.subtenantName == subtenantNames)?.subtenantId || '';

      // Handle multi roles
      if (formData?.role?.length > 1) {
        for (let i = 1; i < formData?.role?.length; i++) {
          await multiRoleAPIFunction(
            responseData?.userId,
            responseData?.id,
            subtenantId,
            data?.role[i],
            true,
            responseData?.createdBy
          );
        }
      }


      // File uploads
      const createdBy = responseData?.createdBy;
      const userId = responseData?.userId;
      const fileId = isNotValidNullUndefile(formData?.profileImage)  ? await fileSignupload(formData?.profileImage, createdBy, userId, 15, 1, 2) : null;
      const signatureId = isNotValidNullUndefile(formData?.signatureImage) ? await fileSignupload(formData?.signatureImage, createdBy, userId, 63, 1, 2) : null;

      // Speaker role
      if (data?.role?.length > 0 && data?.role?.find(ele => ele == 7)) {
         await postspekaeruser(0,userId,data?.speakerDescription,data?.speakerLink,fileId,"Done",true,createdBy,signatureId);
      }


      await updateMemberDataByID(userId, fileId || "", signatureId || "");
       setToast({ message: "Staff created successfully", type: "success"});
        setTimeout(() => {
            setIsOpen(false)
        }, 1000);
    }).catch((error) => {
      if (error?.response?.data?.messages?.[0] === "ALREADY_REGISTERED") {
          setuseLoader(false)
          setToast({ message:error.response.data.messages?.[1], type: "error" });
      }
    }).finally(() => {
      setuseLoader(false);
    });
};
const multiRoleAPIFunction = (userId, loginUserId, subtenantId, roleId, isActive, createdBy) => {
    setuseLoader(true)
    return new Promise((resolve, reject) => {
      Services.postRoleIdData(userId, loginUserId, subtenantId, roleId, isActive, createdBy).then((res) => {
        resolve(res)
      }).catch((err) => {
        resolve('err')
        setuseLoader(false)
      })
    })


  }
  const fileSignupload = (file, createdBy, userId, fileTypeId, fileCategoryId, fileStatusId) => {
    return new Promise((resolve, reject) => {
      Services.postfileuploadspeaker(file, createdBy, userId, fileTypeId, fileCategoryId, fileStatusId).then((res) => {
        let response = res?.data?.data?.fileId
        resolve(response)
      }).catch((err) => {
        resolve('err')
      })
    })



  };
  const updateMemberDataByID = (userId, fileId, signatureId) => {
    setuseLoader(true)
    const {firstName, lastName, email, phone, subtenantName, dob, Citizenship, gender, middleName,charge,wsbaNumber} = formData
    const updatedBy = sessionStorage.getItem("loggedUserId");
    const subtenantId = subtenantdata?.length > 0 && subtenantdata?.filter((data, index) => { return data?.subtenantName == subtenantNames})?.[0]?.subtenantId || ''

    let jsondata = {
      subtenantId: subtenantId, fName: firstName, mName: middleName, lName: lastName, fileId: fileId ?? null,userPrice:charge,wsbaNumber:wsbaNumber,
      signatureId: signatureId ?? null, dob: isNotValidNullUndefile(dob) && dob !== false ? moment(dob).format("YYYY-MM-DD") : "",
      citizenshipId:Citizenship, genderId: gender, userId: userId, updatedBy: updatedBy
    }
    return new Promise((resolve, reject) => {
      Services.subtenantmemberbyuserid(jsondata).then((res) => {
          addressByUserId(userId);
          getUserListData()
       setuseLoader(false)

        resolve(res)
      }).catch((err) => {
        resolve('err')
        setuseLoader(false)
      }).finally(() => {
        setuseLoader(false)
      })
    })

  };
  const postspekaeruser = async (speakerUserId, userId, speakerProfile, videoLinkPath, speakerImageId, remarks, isActive, upsertedBy, speakersignId) => {
    return new Promise((resolve, reject) => {
      Services.postspeakerupsertuser(speakerUserId, userId, speakerProfile, videoLinkPath, speakerImageId, remarks, isActive, upsertedBy, speakersignId).then((res) => {
        resolve(res)
      }).catch((err) => {
        resolve('err')
      }).finally(() => {
      })
    })
  };
  const addressByUserId = (userId) => {
    const { streetAddress, zipCode, country, city, state,longitude,lattitude } = formData;
    const createdBy = sessionStorage.getItem("loggedUserId");

    let addressjson = {
      userId: userId,
      address: {
        lattitude: lattitude,
        longitude: longitude,
        addressLine1: streetAddress,
        addressLine2: "string",
        addressLine3: "string",
        zipcode: zipCode,
        county: country,
        city: city,
        state: state,
        country: country,
        addressTypeId: 1,
        createdBy: createdBy,
      }
    }

    Services.addAddressByuserId(addressjson).then((res) => {
      setuseLoader(false)

    }).catch((err) => {
      setToast({ message: "Enter valid details", type: "error" });
      setuseLoader(false)

    }).finally(() => {
      setuseLoader(false)

    })

  }
  const handleDropDown =(val,name)=>{

   hideErrMsg(`${name}`, errors)
      setFormData((prev) => ({
    ...prev,
    [name]: name == 'role' ? val?.map((item) => item) : val,
  }));
  }





    const allRolesDetails = () => {
        const arr2 = ["1", "4", "2", "5", "9", "10", "12", "17", "18", "19", "20"];
        const roleId = sessionStorage.getItem('roleUserId');
        $CommonServiceFn.InvokeCommonApi("GET", $Service_Url.getUserRoles, '',
            (response) => {
                if (response) {
                    let filterData = response?.data?.data?.length > 0 && response?.data?.data?.filter(element => !arr2.includes(element.value));
                    console.log('hkdajfkdhfkdsjsdk', filterData)
                    setOptionsBackUp(filterData);

                    let filterLegalRoleData = [3, 13, 14, 15];
                    if (roleId == 4 || subtenantId == 3) {
                        filterData = filterData?.length &&  filterData?.filter(x => !filterLegalRoleData.includes(parseInt(x.value)));
                    }

                    setOptions(filterData);

                    setOptionsBackUp(filterData);
                    //  }
                }
            }
        );



    }
    const hideErrMsg = (key, errors) => {
        if (isNotValidNullUndefile(errors[key])) {
            setErrors(prev => ({ ...prev, [key]: '' }));
        }

    }


    const setAddressLine1Data = () => {
          setFormData((prev) => ({
            ...prev,
            streetAddress: searchInput?.current?.value,
          }));
    }

    const autoCompleteAddress = (value, key) => {
        setFormData(prev => ({
            ...prev,
            [key]: value.target.value
        }));

        hideErrMsg(`${key}Err`, errors)
        setErrors(newObjErr())
        initMapScript().then(() => initAutoComplete());
    }
    ////// AUTOCOMPLETE ADDRESS
    const initAutoComplete = () => {
        if (!searchInput.current.value) return;
        const autocomplete = new window.google.maps.places.Autocomplete(
            searchInput.current
        );
        autocomplete.setFields(["address_component", "geometry"]);
        autocomplete.addListener("place_changed", () =>
            onChangeAddress(autocomplete)

        );
    };
    const extractAddress = (place) => {
        const address = {
            city: "",
            state: "",
            zip: "",
            county: "",
            country: "",
            plain() {
                const city = city ? city + ", " : "";
                const zip = zip ? zip + ", " : "";
                const county = county ? county + "," : "";
                const state = state ? state + ", " : "";
                const country = country || "";
                return city + zip + state + country;
            },
        };

        if (!Array.isArray(place?.address_components)) {
            return address;
        }
        let postalCodeSuffix = "";
        let unWanted = ['USA', 'UK'];
        place.address_components.forEach((component) => {
            const types = component.types;
            const value = component.long_name;
            if (types.includes("locality")) {
                address.city = value;
                unWanted.push(component.long_name, component.short_name);
            }
            if (types.includes("administrative_area_level_1")) {
                address.state = value;
                unWanted.push(component.long_name, component.short_name);
            }
            if (types.includes("administrative_area_level_2")) {
                if (value.includes("County") || value.includes("county")) {
                    let removedCountyFromValue = value.replace(/County|county/g, "")
                    address.county = removedCountyFromValue;
                }
                else { address.county = value; }
                unWanted.push(component.long_name, component.short_name);
            }
            if (types.includes("postal_code")) {
                address.zip = value;
                unWanted.push(component.long_name, component.short_name);
            }
            if (types.includes("country")) {
                address.country = value;
                unWanted.push(component.long_name, component.short_name);
            }
            if (types.includes("county")) {
                address.country = value;
                unWanted.push(component.long_name, component.short_name);
            }
            if (types?.includes("postal_code_suffix")) {
                postalCodeSuffix = value;
                unWanted.push(component.long_name, component.short_name);
            }
        });

        if (postalCodeSuffix) address.zip += '-' + postalCodeSuffix;
        unWanted.push(address.zip);

        address.unWanted = unWanted;
        return address;
    };

    const onChangeAddress = (autocomplete) => {
        const place = autocomplete.getPlace();
        const lat = place?.geometry?.location?.lat();
        const long = place?.geometry?.location?.lng();
        setFormData((prev) => ({
            ...prev,
            streetAddress: searchInput?.current?.value,
        }));
        setAddress(extractAddress(place), lat, long);
    };
    const setAddress = (address, lat, long) => {
        address = formateAddressLine1(address);
        setFormData((prev) => ({
            ...prev,
            city: address.city,
            state: address.state,
            zipCode: address.zip,
            country: address?.country,
            lattitude: lat,
            longitude: long
        }));

    };
    const formateAddressLine1 = (address) => {
        if (!address || !searchInput?.current?.value || !address.unWanted?.length) return address;
        const curAddressLine1 = searchInput?.current?.value;
        const firstCommaIndex = curAddressLine1.indexOf(',');
        if (firstCommaIndex == -1) {
            address.unWanted = undefined;
            return address;
        }


        let secondPartString = " " + curAddressLine1?.slice(firstCommaIndex) + " ";

        for (let i = 0; i < address.unWanted.length; i++) {
            const searchWord = new RegExp(`( |,)(${address.unWanted[i]})( |,)`, "g");
            secondPartString = secondPartString?.replace(searchWord, " ");
        }

        let finalSecondPart = "";
        let lastChar = "";
        for (let i = 0; i < secondPartString.length; i++) {
            const curChar = secondPartString[i];
            if (curChar == " " || curChar == ",") {
                if (finalSecondPart.length == 0) continue;
                if (lastChar != " " && (lastChar != "," || curChar == " ")) finalSecondPart += curChar;
            } else {
                finalSecondPart += curChar;
            }
            lastChar = curChar;
        }

        if (finalSecondPart.length) {
            const lastIndexOfCom = finalSecondPart.lastIndexOf(",");
            if (finalSecondPart.length - lastIndexOfCom <= 2) finalSecondPart = finalSecondPart.slice(0, lastIndexOfCom);
            searchInput.current.value = curAddressLine1.slice(0, firstCommaIndex) + ", " + finalSecondPart;
        }
        else searchInput.current.value = curAddressLine1.slice(0, firstCommaIndex);

        address.unWanted = undefined;
        return address;
    }

    const getCitizenship = () => {
        setuseLoader(true)
        let getCitizenshipPromise = Services.getCitizenshipType();
        getCitizenshipPromise
            .then((res) => {
                setCitizenship(res?.data?.data);
                setuseLoader(false)
            })
            .catch((err) => {
                 setuseLoader(false)
                // konsole.log(err);
            });
    };
    const getcountrycodes = () => {
         setuseLoader(true)
        Services.getcountrycode().then((response) => {
            setcountryCode(response?.data?.data);
             setuseLoader(false)
        }).catch((err) => {
            // konsole.log("Error", err);
             setuseLoader(false)
        });
    };

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewOpens, setPreviewOpens] = useState(false);

      const handleDelete = () => {
    setFormData((prev) => ({
      ...prev,
      profileImage: null,
    }));
  };


    const handleDeletes = () => {
    setFormData((prev) => ({
      ...prev,
      signatureImage: null,
    }));
  };
  const genderOptions = [
  { value: "", label: "Gender" },
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
];

    return (
        <>
            {toast && ( <Toaster message={toast?.message} type={toast?.type} onClose={() => setToast(null)}/>)}
           {useLoader &&  <Loader useLoader={useLoader} />}
        <form
            className="w-full max-w-3xl flex flex-col gap-6 overflow-y-auto"
            style={{ maxHeight: "28rem" }}
            onSubmit={handleSubmit}
        >
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    {/* Profile Upload */}

                    <div>
                        {/* Upload box */}
                        <label className="w-24 h-24 border-2 text-center border-dashed border-gray-400 flex items-center justify-center text-xs text-gray-500 cursor-pointer relative group">
                            {formData?.profileImage ? (
                                <img
                                    src={URL.createObjectURL(formData?.profileImage)}
                                    alt="Profile"
                                    className="w-full h-full object-cover rounded"
                                />
                            ) : (
                                "+ Upload Profile Image"
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                //   onChange={handleFileChange}
                                onChange={(e) => handleFileChange(e, "profileImage")}
                            />

                            {/* Action buttons (show only if image is uploaded) */}
                            {formData?.profileImage && (
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition">
                                    <button
                                        type="button"
                                        onClick={() => setPreviewOpen(true)}
                                        className="bg-white text-blue-600 px-2 py-1 rounded text-xs shadow hover:bg-gray-100"
                                    >
                                        👁
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleDelete}
                                        className="bg-white text-red-600 px-2 py-1 rounded text-xs shadow hover:bg-gray-100"
                                    >
                                        🗑
                                    </button>
                                </div>
                            )}
                        </label>

                        {/* Preview Modal */}
                        {previewOpen && (
                            <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
                                <div className="relative max-w-3xl max-h-[90vh]">
                                    <img
                                        src={URL.createObjectURL(formData?.profileImage)}
                                        alt="Preview"
                                        className="rounded-lg object-contain max-h-[90vh] w-auto"
                                    />
                                    {/* Close button */}
                                    <button
                                        type="button"
                                        onClick={() => setPreviewOpen(false)}
                                        className="absolute top-2 right-2 bg-white text-black px-2 py-1 rounded shadow"
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col gap-2">
                        <ReusableSelect
                            options={subtenantdata}
                            value={subtenantId}
                            findValue='subtenantId'
                            onChange={(val) => handleDropDown(val, 'subtenantId', 'subtenantId')}
                            placeholder="Select Subtenant Name"
                            showValue={'subtenantName'}
                            isMulti={false}
                            className='20rem'
                            isDisable={true}
                        />
                        <input type="text" className="px-3 py-2 w-64 invisible" />
                    </div>
                </div>

                {/* Signature Upload */}



                <div className="flex flex-col gap-2" style={{ marginRight: "1rem" }}>
                    <div>
                        <ReusableSelect
                            options={options}
                            value={formData?.role}
                            findValue='value'
                            onChange={(val) => handleDropDown(val, 'role', 'value')}
                            placeholder="Select Role"
                            showValue={'label'}
                            isMulti={true}
                            className='15rem'
                        />
                        {errors?.role && (<p className="text-red-500 text-sm mt-1">{errors?.role}</p>)}

                    </div>


                    {/* Upload box */}
                    <label className="border-2 border-dashed border-gray-400 text-center rounded-md px-4 py-2 text-sm text-gray-600 cursor-pointer relative group">
                        {formData?.signatureImage ? (
                            <img
                                src={URL.createObjectURL(formData?.signatureImage)}
                                alt="Signature"
                                className="h-12 object-contain mx-auto"
                            />
                        ) : (
                            "Upload Signature"
                        )}
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => handleFileChange(e, "signatureImage")}
                        />

                        {/* Action buttons (only if image exists) */}
                        {formData?.signatureImage && (
                            <div className="absolute inset-0 bg-black/40 flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition">
                                <button
                                    type="button"
                                    onClick={() => setPreviewOpens(true)}
                                    className="bg-white text-blue-600 px-2 py-1 rounded text-xs shadow hover:bg-gray-100"
                                >
                                    👁
                                </button>
                                <button
                                    type="button"
                                    onClick={handleDeletes}
                                    className="bg-white text-red-600 px-2 py-1 rounded text-xs shadow hover:bg-gray-100"
                                >🗑
                                </button>
                            </div>
                        )}
                    </label>

                    {/* Preview Modal */}
                    {previewOpens && (
                        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
                            <div className="relative max-w-3xl max-h-[90vh]">
                                <img
                                    src={URL.createObjectURL(formData?.signatureImage)}
                                    alt="Signature Preview"
                                    className="rounded-lg object-contain max-h-[90vh] w-auto"
                                />
                                {/* Close button */}
                                <button
                                    type="button"
                                    onClick={() => setPreviewOpens(false)}
                                    className="absolute top-2 right-2 bg-white text-black px-2 py-1 rounded shadow"
                                >
                                    ✕
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                {/* </div> */}

            </div>


            {/* Personal Info */}
            <div className="border border-dashed p-4 rounded-md">
                <h5 className="font-semibold text-[#720C20] mb-3">
                    Personal Information
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div>
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formData?.firstName}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.firstName && (<p className="text-red-500 text-sm mt-1">{errors?.firstName}</p>
                        )}

                    </div>

                    <div>
                        <input
                            type="text"
                            name="middleName"
                            placeholder="Middle Name"
                            value={formData?.middleName}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />

                    </div>

                    <div>
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formData?.lastName}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.lastName && (
                            <p className="text-red-500 text-sm mt-1">{errors?.lastName}</p>
                        )}

                    </div>

                    <div>
                             <input
                                type="date"
                                name="dob"
                                value={formData?.dob}
                                onChange={handleChange}
                                className="border rounded-md px-3 py-2 w-full"
                                max="9999-12-31"   // prevents >4 digit years
                            />
                    </div>

                    <div>

                           <ReusableSelect
                            options={genderOptions}
                            value={formData?.gender}
                            findValue='value'
                            onChange={(val) => handleDropDown(val, 'gender')}
                            placeholder="Select gender"
                            showValue={'label'}
                            isMulti={false}
                            className='100%'
                        />





                    </div>
                    <div>


                        <ReusableSelect
                            options={citizenship}
                            value={formData?.citizenship}
                            findValue='value'
                            onChange={(val) => handleDropDown(val, 'citizenship', 'subtenantId')}
                            placeholder="Select citizenship"
                            showValue={'label'}
                            isMulti={false}
                            className='100%'
                        />

                    </div>
                </div>
            </div>

            {formData?.role?.some(role => ['3', '13', '14', '15'].includes(role)) &&
                <div className="w-full border border-dashed rounded-md p-4 flex">
                    {/* Consultation Charges */}

                    <div className="w-1/3">
                        <h5 className="text-[#720C20] font-semibold">Consultation Charges</h5>
                        <input
                            type="text"
                            name="charge"
                            value={formData?.charge}
                            onChange={handleChange}
                            placeholder="$"
                            className="w-full mt-1 border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-red-500 focus:outline-none"
                        />
                        {errors?.charge && <p className="text-red-600 text-sm mt-1">{errors?.charge}</p>}
                    </div>
                    {/* WSBA Number (only for role 13) */}
                     {formData?.role?.length > 0 && formData?.role?.find((ele) => ele == 13) && (
                        <div className="w-3/4 ms-3">
                            <h5 className="text-[#720C20] font-semibold">
                                WSBA Number (Washington State Bar Association)
                            </h5>
                            <input
                                type="text"
                                name="wsbaNumber"
                                value={formData?.wsbaNumber}
                                onChange={handleChange}
                                placeholder="Washington State Bar Association"
                                className="w-full mt-1 border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-red-500 focus:outline-none"
                            />
                            {errors?.wsbaNumber && (
                                <p className="text-red-600 text-sm mt-1">{errors?.wsbaNumber}</p>
                            )}
                        </div>
                    )}
                </div>



            }





            {/* Contact Address */}
            <div className="border border-dashed p-4 rounded-md">
                <h5 className="font-semibold text-[#720C20] mb-3">
                    Contact Address
                </h5>

                <input

                    type="text"
                    placeholder="Enter billing address"
                    name="address"
                    ref={searchInput}
                    defaultValue={formData?.streetAddress}
                    onBlur={setAddressLine1Data}
                    onChange={(e) => autoCompleteAddress(e, 'streetAddress')}
                    className="border rounded-md px-3 py-2 w-full mb-3"
                />






                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">



                    <div>
                        <input
                            type="text"
                            name="city"
                            placeholder="City"
                            value={formData?.city}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.cityErr && (<p className="text-red-500 text-sm mt-1">{errors?.cityErr}</p>)}
                    </div>
                    <div>
                        <input
                            type="text"
                            name="state"
                            placeholder="State"
                            value={formData?.state}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.stateErr && (<p className="text-red-500 text-sm mt-1">{errors?.stateErr}</p>)}
                    </div>
                    <div>
                        <input
                            type="text"
                            name="country"
                            placeholder="Country"
                            value={formData?.country}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.countryErr && (<p className="text-red-500 text-sm mt-1">{errors?.countryErr}</p>)}
                    </div>
                    {/* <br/> */}
                    <div>
                        <input
                            type="text"
                            name="zipCode"
                            placeholder="Zip Code"
                            value={formData?.zipCode}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.zipCodeErr && (<p className="text-red-500 text-sm mt-1">{errors?.zipCodeErr}</p>)}
                    </div>
                </div>
            </div>













            {/* Contact Information */}
            <div className="border border-dashed p-4 rounded-md">
                <h5 className="font-semibold text-[#720C20] mb-3">
                    Contact Information
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData?.email}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.email && (
                            <p className="text-red-500 text-sm">{errors?.email}</p>
                        )}
                    </div>
                    <div>

                        <ReusableSelect
                            options={countrycode}
                            value={formData?.countryCode}
                            findValue='value'
                            onChange={(val) => handleDropDown(val, 'countryCode')}
                            placeholder="Select Country Code"
                            showValue='label'
                            isMulti={false}
                            className='100%'
                            openUp={true}
                        />
                    </div>

                    <div>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Cell Number"
                            value={formData?.phone}
                            onChange={handleChange}
                            className="border rounded-md px-3 py-2 w-full"
                        />
                        {errors?.phone && (
                            <p className="text-red-500 text-sm">{errors?.phone}</p>
                        )}

                    </div>
                </div>
            </div>

            {formData?.role?.length > 0 && formData?.role?.find(ele => ele == 7) &&
                <div className="w-full mt-4">
                    <div className="w-full border border-dashed  rounded-md p-4">
                        {/* Header */}
                        <h5 className="text-[#720C20] mb-2 font-semibold">About</h5>
                        {/* Speaker Link */}
                        <div>
                            <label className="block font-semibold mb-1 text-[#720C20]">Speaker Link</label>
                            <input
                                type="text"
                                name="speakerLink"
                                value={formData?.speakerLink}
                                onChange={handleChange}
                                placeholder="Enter Link"
                                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-red-500 focus:outline-none"
                            />
                            {errors?.speakerLink && (
                                <p className="text-red-600 text-sm mt-1">{errors?.speakerLink}</p>
                            )}
                        </div>

                        {/* Speaker Description */}
                        <div>
                            <label className="block  font-semibold mb-1 text-[#720C20] mt-1">Speaker Description</label>
                            <textarea
                                name="speakerDescription"
                                value={formData?.speakerDescription}
                                onChange={handleChange}
                                rows={4}
                                placeholder="Enter Speaker Description"
                                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-red-500 focus:outline-none"
                            />
                            {errors?.speakerDescription && (
                                <p className="text-red-600 text-sm mt-1">{errors?.speakerDescription}</p>
                            )}
                        </div>
                    </div>
                </div>
            }


            {/* Footer */}
            <div className="flex justify-end gap-4">
                <button
                    type="button"
                    className="px-4 py-2 rounded-md bg-white-100 text-[#720C20] border border-[#720C20]"
                    onClick={() => setIsOpen(false)}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 rounded-md bg-[#720C20] text-white"
                >
                    Save
                </button>
            </div>
        </form>
        </>
    );
};

export default AddStaff;




